/**
 * Finds the nearest parent with scroll in it
 */
export function prizmGetScrollParent(element: Element | null, vertical = true): Element | null {
  if (element === null) {
    return null;
  }

  if (vertical && element.scrollHeight > element.clientHeight) {
    return element;
  }

  if (!vertical && element.scrollWidth > element.clientWidth) {
    return element;
  }

  return prizmGetScrollParent(element.parentElement, vertical);
}
